import React, { useEffect, useRef } from 'react';
import './CameraPiPView.css';

const CameraPiPView = ({ children, isConnected = true }) => {
  const contentRef = useRef(null);

  useEffect(() => {
    // Find all video elements and disable PiP button
    const findAndConfigureVideos = () => {
      if (contentRef.current) {
        const videos = contentRef.current.querySelectorAll('video');
        videos.forEach(video => {
          // Remove PiP button from native controls
          video.setAttribute('controlsList', 'nopictureinpicture');
          video.disablePictureInPicture = true;
        });
      }
    };

    // Initial configuration
    findAndConfigureVideos();

    // Observe for dynamically added video elements
    const observer = new MutationObserver(() => {
      findAndConfigureVideos();
    });

    if (contentRef.current) {
      observer.observe(contentRef.current, {
        childList: true,
        subtree: true
      });
    }

    return () => {
      observer.disconnect();
    };
  }, [children]);

  return (
    <div className="camera-pip-view">
      <div className="camera-pip-view__header">
        <div className="header__title">
          <h3>UAV CAM</h3>
          <div className="connection-status">
            <span className={`status-indicator ${isConnected ? 'connected' : 'disconnected'}`}></span>
            <span className="status-text">{isConnected ? 'Live' : 'Offline'}</span>
          </div>
        </div>
      </div>
      
      <div className="camera-pip-view__content" ref={contentRef}>
        {children}
      </div>
    </div>
  );
};

export default CameraPiPView;

